import { mapState, mapGetters, mapActions } from 'vuex'

export const authComputed = {
  ...mapState('auth', {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions('auth', [
  'logIn',
  'logOut',
  'contactAdmin',
  'getNewToken',
])
export const navbarMethods = mapActions('navbar', ['getNavMenu'])
export const lenderMethods = mapActions('lenders', [
  'fetchLenders',
  'fetchTotalLenders',
  'saveLender',
  'updateLender',
  'storeLender',
  'fetchLenderById',
  'downloadlenderReport',
  'fetchCreditAgencies',
  'fetchNotificationPreferences',
  'uploadLenderImage',
])
// TODO: Review productMethods
export const productMethods = mapActions('products', [
  'fetchProducts',
  'fetchCustomerUser',
  'createProduct',
  'updateProduct',
  'fetchProductsByUserId',
  'updateProductUrl',
  'fetchProductsTotalRecords',
  'fetchProductById',
  'downloadProductReport',
  'uploadProductImage',
  // 'fetchLoanOfficerURLRecord',
  // 'fetchTotalCustomizeProductURLRecords',
])
export const userMethods = mapActions('users', [
  'storeUser',
  'unlockUser',
  'fetchTotalUsers',
  'fetchUsers',
  'fetchxactusUsers',
  'downloadUserReport',
  'resendEmailToUsers',
  'fetchRoleOption',
  'fetchUserRolesOption',
  'fetchSuffixOption',
  'createNewUser',
  'updateExistingUser',
  'getUserDetails',
  'fetchUserById',
  'fetchUserForEdit',
  'updateStore',
  'fetchCustomer',
  'fetchCustomersUserId',
  'fetchCustomerApiScopes',
  'fetchProductsApiScopes',
  'updateprofile',
  'isUserNameExists',
  'validateuser',
  'searchCustomersByUserId',
  'fetchAMSCompanies',
  'fetchAllSkills',
  'fetchAllPackagesCustomer',
  'getIsFraudPlusCustomer',
  'getSecurityQuestions',
  'getUserSecurityQAByUserId',
  'verifyAnswers',
  'generatePassword',
  'sendPasswordToEmail',
])

export const customerMethods = mapActions('customers', [
  'fetchCustomers',
  'fetchHomeProvider',
  'fetchMasterCustomer',
  'createNewCustomer',
  'updateCustomer',
  'fetchCustomerById',
  'fetchAPIScopes',
  'fetchCustomersByUserId',
  'fetchAmsSubscribedCustomers',
  'fetchallcustomersbyuserid',
  'fetchproviderbyuserid',
  'fetchMasterCustomersByUserId',
  'fetchTransactionCustomersByUserId',
  'searchCustomersByUserId',
  'fetchAMSCustomerCompanies',
  'fetchCustomTemplates',
  'fetchAllPackages',
  'fetchCustomersReport',
  'downlaodcustomersreport',
  'fetchusersReport',
  'downloadUsersReport',
  'fetchSalesRepresentatives',
  'fetchCustomersForReports',
])
export const loanOfficerMethods = mapActions('loanOfficers', [
  'storeLoanOfficerId',
  'createLoanOfficer',
  'updateLoanOfficer',
  'getloanofficers',
  'downloadLoanOfficerReport',
  'getTotalLoanOfficer',
  'fetchLoanOfficersById',
  'resendEmailForLoanOfficer',
  'fetchUserRolesOption',
  'fetchSuffixOption',
])
export const reportMethods = mapActions('reports', [
  // 'fetchConsentReports',
  // 'fetchTotalConsentReport',
  'fetchTotalActivityReport',
  // 'fetchActivityDetailsReport',
  // 'fetchActivityReport',
  // 'downloadTotalConsentReport',
  'downloadTotalActivityReport',
  'fetchUserSettings',
  'fetchTimeZones',
  'fetchUsageReports',
  'DownloadUsageReports',
  'fetchOrderSummaryDetails',
  'fetchCCRSummaryData',
  'fetchPendingReport',
  'fetchUsageReportsAdvanced',
  'fetchCostForBorrowerReport',
  'fetchPendingForFlood',
  'getInvoiceByOrderId',
  'fetchInvoiceReport',
  'updateDiscount',
])

export const documentMgmtMethods = mapActions('docMgmt', ['fetchDocumentsData'])

export const prequalMethods = mapActions('prequaltemplate', [
  'getcustomerlogo',
  'getPrequalTheme',
  'savePrequalTheme',
  'savePreqPageStyle',
  'saveProdPageStyle',
  'getAppPageStyle',
  'getPrequalTemplate',
  'saveAppPageStyle',
  'savePrequalTemplate',
])

export const changePasswordMethods = mapActions('changepassword', [
  'updatePassword',
  'fetchSecurityQuestion',
  'logOut',
  'fetchAccountTokenIsValid',
  'activateUserAccount',
  'isUserNameExists',
  'resetNewPassword',
  'fetchResetTokenIsValid',
  'validateUser',
  'resetPasswordOnLogin',
  'getUserSecurityQuestions',
  'validateSecurityQuestions',
])

export const hmdaMethods = mapActions('hmdaModule', [
  'createProject',
  'getBlobsInContainer',
  'getOrCreateContainer',
  'uploadBlob',
  'uploadLoanFiles',
  'fetchProjectsList',
  'fetchRulesList',
  'fetchProjectFiles',
  'fetchLoanDetail',
  'fetchLoanHeader',
  'fetchAttrComment',
  'postLoan',
  'postRunRules',
  'fetchLARSummary',
  'downloadLAR',
  'generateLAR',
  'approveLARDownload',
  'fetchActivityLogs',
  'fetchProjectSummary',
  'fetchProjectNewLoans',
  'fetchProjectPassedLoans',
  'fetchProjectFailedLoans',
  'fetchProjectDatatypeLoans',
  'fetchUploadedFilesErrorList',
  'actionOnDuplicateLoans',
  'downloadErrorListCsv',
  'fetchProjectDashboard',
  'updateProject',
  'fetchProjectErrorSummary',
  'getContainerID',
  'setSelectedCustomer',
  'setSelectedUser',
  'getSelectedCustomer',
  'getSelectedUser',
  'fetchAllHmdaCustomers',
  'fetchAllCustomerUsers',
  'saveLei',
  'fetchLei',
  'setHMDAConfigData',
  'getRateSpreadValue',
  'getGeoCodeValue',
  'fetchULIComment',
  'fetchProjectDeletedLoans',
  'deleteLoanSingle',
  'deleteLoanBatch',
  'downloadFailedLoansCsv',
])
export const hmdaGetters = mapGetters('hmdaModule', [
  'projectSummary',
  'filesErrorList',
  'filesUploadedList',
  'projectErrorSummary',
])

export const notificationActions = mapActions('notifications', [
  'setBellBadge',
  // 'getNotification',
])
export const notificationGetters = mapGetters('notifications', [
  'notifications',
  'isShowBellBadge',
  'enableNotification',
])

export const broadcastActions = mapActions('broadcast', [
  // 'startBroadcastConnection',
  // 'stopBroadcastConnection',
])
export const broadcastGetters = mapGetters('broadcast', [
  'broadcastMessages',
  'messageTypeFileUpload',
  'messageTypeRuleEngine',
])

export const orderReportMethods = mapActions('orderReport', [
  'fetchCustomer',
  'fetchCustomerUser',
  'fetchCustomerById',
  'fetchUserForEdit',
  'fetchUserProduct',
  'fetchFloodReport',
  'fetchServicelinkFloodReport',
  'fetchOrderCCRReport',
  'fetchOrderSupplement',
  'fetchOrderEditSupplement',
  'fetchRescore',
  'fetchRescoreProcessor',
  'submitFaxIntegration',
  'fetchFaxIntegration',
  'previewFaxIntegration',
  'rescoreRepullRequest',
  'getRescoreDocument',
  'submitRescoreRequest',
  'submitRescoreProcessor',
  'fetchOrderSupplementQueue',
  'saveOrderSupplementQueue',
  'updateMyQueue',
  'updateMyQueueList',
  'saveOrderSupplement',
  'updateEditSupplement',
  'fetchCreditManagerOrProcessors',
  'fetchCustomerDetails',
  'fetchBCRCCROrderReport',
  'fetchSaveAsDraftMethod',
  'fetchBCRCCRDraftReport',
  'deleteAuthorizationForm',
  'fetchSearchCompanyResult',
  'fetchOrderBCIRTrade',
  'uploadForm',
  'fetchCustomerProducts',
  'fetchCCRSummaryData',
  'checkReportExpiryTime',
  'getCCROrderData',
  'getPDFForRemove',
  'orderReportForRemove',
  'getRequesterInfo',
  'getCustomerList',
  'getUserList',
  'updateRequester',
  'fetchOrderLimits',
  'getOrderLinkStatus',
  'fetchPrintSupplementReport',
  'GetPDFForSupplement',
  'getSupplementDocument',
])

export const settingsMethods = mapActions('settings', [
  'getUserSettings',
  'saveUserSettings',
])

export const ofacReportMethods = mapActions('ofacReports', [
  'fetchOfacPrincipalReport',
  'fetchOfacCommercialReport',
])

export const experianBusinessOwnerProfileReportMethods = mapActions(
  'experianBusinessOwnerProfileReport',
  ['fetchExperianBusinessOwnerProfileReport']
)

export const liensandJudgementsMethods = mapActions('liensandJudgment', [
  'fetchLiensAndJudgementReport',
  'refreshLiensAndJudegementReport',
  'updateRecordStatus',
  'getLnjOrderSummaryReport',
  'GetLnjSupplementOrderDetails',
  'saveLnJSupplement',
  'submitSupplement',
  'submitSaveNote',
  'deleteSavedNote',
  'updateNote',
])

export const experianPremierProfileReportMethods = mapActions(
  'premierProfileReport',
  ['fetchPPRSearchReport', 'fetchPremierProfileReport']
)

export const forgotPasswordMethods = mapActions('forgotpassword', [
  'fetchOTPOptions',
  'sendotp',
  'validateotp',
])

export const volumeReportMethods = mapActions('volumereport', [
  'fetchCustomer',
  'fetchVolumeReport',
  'downloadVolumeReports',
  'fetchCustomerProducts',
])

export const billingReportMethods = mapActions('billingReport', [
  'fetchCustomer',
  'fetchBillingReport',
  'downloadBillingReport',
  'fetchCustomerProductforBillingreport',
])
export const transactionreportMethods = mapActions('transactionReport', [
  'fetchCustomer',
  'fetchTransactionReport',
  'downloadTransactionReport',
  'fetchCustomerProducts',
])

export const activityReportMethods = mapActions('activitySummaryReport', [
  'fetchCustomer',
  'fetchActivityReport',
  'downloadActivityReport',
])

export const denaliReportMethods = mapActions('denaliReport', [
  'fetchDenaliReport',
  'updateDenaliReport',
])

export const scoreReportMethods = mapActions('scoreReport', [
  'fetchCustomer',
  'fetchScoreReport',
  'downloadScoreReport',
])
export const mclSavePasswordMethods = mapActions('saveMclCredentials', [
  'savePassword',
  'fetchMclCredentialsById',
])

export const thirdPartyVendorsMethods = mapActions('thirdPartyVendors', [
  'getManageThirdPartyVendors',
  'getReportingAgenctData',
  'updateThirdPartyVendors',
])

export const globalTaxSetup = mapActions('globalTaxSetup', [
  'fetchTaxTableData',
  'saveTaxTableData',
  'updateTaxTableData',
  'deleteTaxTableData',
])

export const documentMethods = mapActions('document', [
  'fetchDocuments',
  'uploadDocument',
  'deleteDocument',
  'downloadDocument',
  'getPdfData',
])

export const ipwhitelistMethods = mapActions('ipwhitelisting', [
  'sendOTP',
  'validateotp',
])
export const mclOTPMethods = mapActions('mclotp', [
  'verifyuser',
  'sendOTP',
  'validateotp',
  'fetchOTPOptions',
])

export const rolodexMethods = mapActions('rolodexSetup', [
  'fetchRolodexData',
  'createRolodex',
  'updateRolodex',
  'deleteRolodex',
])

export const exceptionMethods = mapActions('exceptionHandling', [
  'getAllExceptions',
  'getAllSourceTypes',
  'createException',
  'updateException',
  'getSupportEmailId',
  'updateSupportEmailId',
])

export const rateSheetMethods = mapActions('rateSheet', [
  'getRateSheetData',
  'postRateSheetData',
])

export const scoreDisclosureMethods = mapActions('scoreDisclosure', [
  'getScoreDisclosure',
  'downloadReports',
  'uploadReport',
  'fetchCustomer',
  'sendNotication',
  'fetchCustomersByUserIdFamm',
])

export const monitoringServicesMethods = mapActions('monitoringServices', [
  'getCompanies',
  'getCompanyDetail',
  'downloadCompanies',
  'addCompanies',
  'removeCompanies',
  'updateCompanies',
  'fetchPortfolios',
  'getalertslist',
  'downloadalerts',
  'getalertdetails',
  'fetchCustomersByUserId',
  'getcustomeralerts',
])

export const consumerConsentReportMethod = mapActions('consumerConsentReport', [
  'fetchConsentReports',
  'fetchActivityReport',
  'fetchActivityDetailsReport',
  'downloadTotalConsentReport',
  'downloadconsumeractivityreport',
  'getconsumeractivityreportDetails',
])

export const fraudplusMethod = mapActions('fraudPlus', [
  'fetchFraudplusPackages',
  'fetchFPlusPackageDetails',
  'enableDisableFraudPlusPackage',
  'createFPlusPackage',
  'saveFPlusPackage',
  'saveSelectedCustomers',
  'fetchAllCustomers',
  'fetchselectedCustomers',
  'getFraudPlusPricingData',
  'postFraudPlusPricingData',
  'getFraudplusFinalReport',
  'fetchFraudXPDF',
  'getFraudPlusOrderSummary',
  'saveRemarks',
  'saveStatus',
  'putAction',
  'getManageList',
  'getCustomerList',
  'editCustomerList',
  'deleteCustomerList',
  'getCustomerPackage',
  'fetchFPlusRolesForBridger',
  'fetchARSFraudXSortData',
  'fetchFRaudXPackageDetails',
  'getFraudPlusViewReport',
])

export const fraudplusOrderReportMethod = mapActions('fraudPlusOrderReport', [
  'fetchFraudPlusDistanceCalculation',
  'fetchPackagesforUser',
  'fetchPackagesforUserOrder',
])

export const customLayoutMethod = mapActions('customLayout', [
  'getAllTemplates',
  'removeLayoutTemplate',
  'fetchLayoutDetails',
  'commitLayoutDesigner',
  'verifyTemplateAssociation',
])

export const voeReportMethods = mapActions('voeReports', [
  'generateVoEManualreports',
  'generateVoEreports',
  'getVoEOrderHistory',
  'fetchPdfForOrderVoe',
  'getVoEreverify',
  'fetchSubOrderDetail',
  'fetchAuthFormValidation',
  'getVoeProcessing',
  'uploadVoeDocument',
  'updateVoeManual',
  'verifyVoeOTP',
  'uploadDocument',
  'sendVoeVerification',
  'voeResendOtp',
  'voeSecuredLink',
  'sendSecuredData',
  'sendSecured',
  'deleteDoc',
  'getVoEManual',
  'getVoEManulreverify',
  'generateManualreports',
])
export const floodReportMethods = mapActions('floodReport', [
  'generateFloodSummary',
  'upgradeLifeOfLoanClicked',
  'transferToLenderClicked',
  'transferToLenderProceed',
  'recertifyClicked',
])

export const voaReportMethods = mapActions('voaReports', [
  'generateVoAreports',
  'fetchVoAreports',
  'generatepdfReports',
  'resendInvitationEmail',
])

export const voaFiservReportMethods = mapActions('voaFiservReports', [
  'generateVoAFiservreports',
  'fetchVoAFiservreports',
  'resendInvitationEmail',
  'sendVoaFiservVerification',
  'fetchSignonInfo',
  'voaFiservDeleteUser',
  'generatepdfReport',
  'viewpdfReport',
  'voaAccountsEnrolled',
  'voaFiservNoOtpGuid',
  'fetchMaxDataReport',
])

export const vomFiservReportMethods = mapActions('vomFiservReports', [
  'generateVoMFiservreports',
  'fetchVoMFiservreports',
  'resendInvitationEmail',
  'sendVomFiservVerification',
  'verifyVomFiservOTP',
  'vomFiservResendOtp',
  'vomFiservOtpExpire',
  'fetchSignonInfo',
  'vomFiservDeleteUser',
  'generatepdfReport',
  'vomGenerateReport',
  'getAccountsInfo',
  'getVomFiservSummary',
  'vomFiservResendEmail',
  'vomAccountsEnrolled',
  'vomFiservCancelOrder',
  'vomFiservRetry',
  'vomNoOtpGuid',
])

export const bureauConnectionMethods = mapActions('bureauConnections', [
  'fetchBureauConnections',
  'createConnectionSubmit',
  'fetchConnectionDetails',
  'updateConnectionSubmit',
  'enableDisableConnection',
  'fetchSelectedBureauCustomers',
  'saveSelectedBureauCustomers',
  'getBureauCustomer',
  'getConnectionByName',
])
export const voeSelfVerificationMethods = mapActions(
  'voeSelfEmployeeVerification',
  [
    'uploadVoeReportFile',
    'getVoeSelfSecureLinkDetails',
    'deleteVoeSelfFiles',
    'saveSecureLinkDetails',
    'getSelfOrderDetails',
    'getAssignedTo',
    'submitSelfVerification',
    'getSelfOrderReport',
    'sendVoeSelfVerification',
    'generateVoeSelfReport',
    'saveProcessingDetails',
    'voeSelfSendOtp',
    'voeSelfVerifyOtp',
    'voeSelfOtpExpiry',
  ]
)

export const vodReportMethods = mapActions('vodReport', [
  'generateVoDreports',
  'getVodOrderListDetails',
  'getVodGenerateReport',
  'updateVodManual',
  'sendVodVerification',
  'verifyVodOTP',
  'vodResendOtp',
  'getSecureLinkDetails',
  'saveSecureLinkDetails',
  'vodOtpExpire',
  'uploadFiles',
  'deleteFiles',
  'getVodReport',
])

export const dashboardMethods = mapActions('dashboard', [
  'getAmsApi',
  'getProductOrder',
  'getTop10CustomersApi',
  'getReissueApi',
  'getManualRequestApi',
])

export const udnMethods = mapActions('udn', [
  'getUdnOrderData',
  'sendUdnOrderData',
  'getUdnSummaryData',
  'getCcrValidOrderStatus',
  'updateNotificationEmails',
  'getBureusForStandAlone',
  'deactivateRequest',
])

// export const toasterMethods = {
//   ...mapActions('toaster', ['setAlert']),
//   // ...mapGetters('toaster', ['showToastMessage']),
// }

export const toasterMethods = mapActions('toaster', ['setAlert', 'clearAlert'])
export const toasterGetters = mapGetters('toaster', ['getToast'])
export const fiservMethods = mapActions('fiservReport', [
  'fetchSessionId',
  'fetchWidgets',
])
export const fPlusIntegration = mapActions('fPlusIntegration', ['setToken'])
export const saveSearchResults = mapActions('saveSearchModule', [
  'saveSearchData',
  'setSummaryStatus',
])
export const fPlusIntegrationMethods = mapActions('fPlusIntegrationModule', [
  'fetchFPlusIntegrationPackages',
  'createFPlusIntegrationPackage',
  'fetchFPlusIntegrationPkgDetails',
  'saveFPlusIntegrationPackage',
  'fetchFPlusCustomerDetails',
  'getFraudReportIntegrationData',
  'fetchFraudXIntegrationPDF',
  'saveFraudReportIntegrationStatus',
  'saveFraudReportIntegrationRemarks',
  'toggleFPlusPackageStatus',
  'fetchARSIntegrationSortData',
])
export const experianBlendedReportMethods = mapActions(
  'experianBlendedReport',
  [
    'fetchBlendedSearchReport',
    'orderExpBlendedReport',
    'fetchExpBlendedReportSummary',
    'retryExperianBlendedReport',
  ]
)
export const equifaxPaynetReportMethods = mapActions('equifaxPaynetReport', [
  'fetchEQPaynetSearchReport',
  'orderEquifaxPaynetReport',
])
export const getActiveLogsMethods = mapActions('logs', ['getActiveLogs'])

export const sessionLogMethods = mapActions('sessionLogs', ['sendLogToAPI'])
